const formatNumberOfSearchGames = (numberOfGames?: number): string => {
  const numberOfSearchGames =
    numberOfGames && numberOfGames > 500
      ? Math.floor(numberOfGames / 100) * 100
      : 500;

  return new Intl.NumberFormat('en-GB').format(numberOfSearchGames);
};

export default formatNumberOfSearchGames;
